import URL from '@/tools/url';
import EventBus from '@/event-bus';
import getSeoFilter from '@/ajax/collection/seo-filter';

export default function() {
  const selectedFilter = URL.selectedFilter;

  return new Promise((resolve, reject) => {
    if (window.__SeoFilterInProcess) {
      EventBus.subscribe('seo-filter:insales:system', function(filter) {
        resolve(filter);
      });
    } else {
      window.__SeoFilterInProcess = true;

      getSeoFilter()
        .then((seoFilter) => {
          return Object.assign({}, selectedFilter, seoFilter);
        })
        .then((filter) => {
          EventBus.publish('seo-filter:insales:system', filter);

          resolve(filter);
        })
        .catch(result => {
          reject(result);
        });
    }
  });
}
